import type { AccordionDetailsProps as MuiAccordionDetailsProps } from '@mui/material';
import { AccordionDetails as MuiAccordionDetails } from '@mui/material';

export type AccordionDetailsProps = MuiAccordionDetailsProps;

/** Shows accordion details in an accordion component. Based on MUI Accordion Details: https://mui.com/material-ui/api/accordion-details */
export const AccordionDetails = (props: AccordionDetailsProps) => (
  <MuiAccordionDetails {...props} />
);
